import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import MediaQuery from "react-responsive";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "src/pages/app";
import { breakpoints, i18n, mediaQuery } from "src/common";
import { AdditionalCoveragesCard, Button, Divider, DropdownDownIcon, Flex, Loader } from 'src/components';
import { colors } from "src/theme";
import { Card } from "./card";
import { CoveragesCard } from "./coverages.card";
import { OfferHeaderCard } from "./parts/offerHeader.part";

const CardStyle = styled(Card)({
  padding: '12px',

  [mediaQuery('mobile')]: {
    padding: '20px'
  },
})

const ButtonStyle = styled(Button)({
  width: '100%',

  [mediaQuery('mobile')]: {
    width: 'auto'
  },
})

interface OfferCardProps {
  offer: any;
  loading?: boolean;
  oneTimeToggle?: boolean;
  className?: string;
}

export const OfferSoCard = ({ offer, loading, oneTimeToggle = false, className }: OfferCardProps) => {
  const navigate = useNavigate();

  const [isMoreDetailsOpen, setIsMoreDetailsOpen] = useState(false);
  const [isYearToggleChecked, setIsYearToggleChecked] = useState(oneTimeToggle);

  useEffect(() => {
    setIsYearToggleChecked(oneTimeToggle);
  }, [oneTimeToggle]);

  if (loading) {
    return (
      <Card radius={12} padding={20} className={className}>
        <Loader />
      </Card>
    )
  }

  const discountPercentage = ((offer.total.generalTransferWithInstallments - offer.total.generalTransfer) / offer.total.generalTransferWithInstallments) * 100;
  const roundedDiscountPercentage = Math.round(discountPercentage); // Zaokruživanje na više bez decimalnih mjesta

  const selectOffer = () => {
    navigate(`${AppRoutes.OFFER.fullPath}/${offer.publicOfferId}`);
  }

  return (
    <CardStyle radius={12} padding={20} className={className}>
      <Flex vertical gap={12}>
        <OfferHeaderCard
          brandName={offer.supplementary.brandName}
          offerLabel={offer.supplementary.label}
          price={isYearToggleChecked ? offer.total.generalTransfer : (offer.total.generalTransferWithInstallments / 12)}
          priceType={isYearToggleChecked ? 'yearly' : 'monthly'}
          logoUrl={offer.supplementary.logoUrl}
          discountPercentage={roundedDiscountPercentage}
          handlePriceTypeChange={() => setIsYearToggleChecked(!isYearToggleChecked)}
        />
        <Divider dashed />

        <MediaQuery maxWidth={breakpoints.mobile - 1}>
          <CoveragesCard coverages={offer.supplementary.includedInPrice} isExpanded={false} expandable title={offer.supplementary.label} />
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.mobile}>
          <CoveragesCard coverages={offer.supplementary.includedInPrice} additionalCoverages={offer.supplementary.additionalCoverages} isExpanded={isMoreDetailsOpen} />
        </MediaQuery>

        <Flex justify='space-between' gap={8}>
          <MediaQuery minWidth={breakpoints.mobile}>
            <Button
              btnType="textPrimary"
              iconPosition="right"
              onClick={() => { setIsMoreDetailsOpen(!isMoreDetailsOpen) }}
              text={isMoreDetailsOpen ? i18n.t('pages.offersPage.hideDetails') : i18n.t('pages.offersPage.showDetails')}
            >
              <DropdownDownIcon color={colors.icon4} isOpen={isMoreDetailsOpen} />
            </Button>
          </MediaQuery>
          <ButtonStyle
            btnType="primary"
            onClick={() => selectOffer()}
            text="Kupi"
          />
        </Flex>
        {offer.supplementary.additionalCoverages && offer.supplementary.additionalCoverages.length > 0 && <MediaQuery maxWidth={breakpoints.mobile - 1}>
          <Divider dashed />
          <AdditionalCoveragesCard additionalCoverages={offer.supplementary.additionalCoverages} />
        </MediaQuery>}
      </Flex>
    </CardStyle>
  )
};

